import { asyncAction } from 'store/utils/promiseAction';
import { action } from 'typesafe-actions';

import { CompanyUsersInterface, CompanyUsersTypes } from './types';

// Check Company Users
export const checkCompanyUsersRequest = (payload: object) =>
  action(CompanyUsersTypes.CHECK_COMPANY_USERS_REQUEST, payload);

export const checkCompanyUsersSuccess = (payload: {
  checkCompanyUsersList: CompanyUsersInterface[];
}) => action(CompanyUsersTypes.CHECK_COMPANY_USERS_SUCCESS, payload);

export const checkCompanyUsersFaliure = () =>
  action(CompanyUsersTypes.CHECK_COMPANY_USERS_FAILURE);

// Check Company Users
export const chargeRequestExternRequest = (payload: { formData: File[] }) =>
  asyncAction(CompanyUsersTypes.CHARGE_REQUEST_EXTERNAL_REQUEST, payload);

export const chargeRequestExternSuccess = () =>
  action(CompanyUsersTypes.CHARGE_REQUEST_EXTERNAL_SUCCESS);

export const chargeRequestExternFailure = () =>
  action(CompanyUsersTypes.CHARGE_REQUEST_EXTERNAL_FAILURE);

// List Company Users
export const listCompanyUsersRequest = (payload: object) =>
  action(CompanyUsersTypes.LIST_COMPANY_USERS_REQUEST, payload);

export const listCompanyUsersSuccess = (payload: {
  companyUsersList: CompanyUsersInterface[];
  totalCount: number;
}) => action(CompanyUsersTypes.LIST_COMPANY_USERS_SUCCESS, payload);

export const listCompanyUsersFaliure = () =>
  action(CompanyUsersTypes.LIST_COMPANY_USERS_FAILURE);

// Create Company Users
export const createCompanyUsersRequest = (payload: {
  body: {
    name: string;
    dcument: string;
  };
  redirectTo?: string;
}) => action(CompanyUsersTypes.CREATE_COMPANY_USERS_REQUEST, payload);

export const createCompanyUsersSuccess = (payload: {
  companyUsersData: CompanyUsersInterface;
}) => action(CompanyUsersTypes.CREATE_COMPANY_USERS_SUCCESS, payload);

export const createCompanyUsersFailure = () =>
  action(CompanyUsersTypes.CREATE_COMPANY_USERS_FAILURE);

// Update Company Users
export const updateCompanyUsersRequest = (payload: {
  body: object;
  redirectTo?: string;
}) => action(CompanyUsersTypes.UPDATE_COMPANY_USERS_REQUEST, payload);

export const updateCompanyUsersSuccess = (payload: {
  companyUsersData: CompanyUsersInterface;
}) => action(CompanyUsersTypes.UPDATE_COMPANY_USERS_SUCCESS, payload);

export const updateCompanyUsersFailure = () =>
  action(CompanyUsersTypes.UPDATE_COMPANY_USERS_FAILURE);

// Delete Company Users
export const deleteCompanyUsersRequest = (payload: object) =>
  action(CompanyUsersTypes.DELETE_COMPANY_USERS_REQUEST, payload);

export const deleteCompanyUsersSuccess = () =>
  action(CompanyUsersTypes.DELETE_COMPANY_USERS_SUCCESS);

export const deleteCompanyUsersFailure = () =>
  action(CompanyUsersTypes.DELETE_COMPANY_USERS_FAILURE);

// Delete Company User
export const deleteCompanyUserRequest = (payload: object) =>
  action(CompanyUsersTypes.DELETE_COMPANY_USER_REQUEST, payload);

export const deleteCompanyUserSuccess = () =>
  action(CompanyUsersTypes.DELETE_COMPANY_USER_SUCCESS);

export const deleteCompanyUserFailure = () =>
  action(CompanyUsersTypes.DELETE_COMPANY_USER_FAILURE);
